import React from "react"

export default function WebIcon() {
  return (
    <svg
      width="62"
      height="60"
      viewBox="0 0 62 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="white-fill"
        d="M7.24445 5.66858H54.7947L54.7948 38.6533H7.24445V5.66858Z"
        fill="#4996FF"
      />
      <path
        className="white-fill"
        d="M54.7737 40.9755H7.22599L0.581482 50.9094V53.9171H61.4208V50.9094L54.7737 40.9755Z"
        fill="#4996FF"
      />
      <path
        className="blue-fill"
        d="M24.1443 21.3901H16.2545V23.2568H24.1443V21.3901Z"
        fill="white"
      />
      <path
        className="blue-fill"
        d="M24.1443 15.6797H16.2545V17.5464H24.1443V15.6797Z"
        fill="white"
      />
      <path
        className="blue-fill"
        d="M44.9061 16.105H28.0352V17.9717H44.9061V16.105Z"
        fill="white"
      />
      <path
        className="blue-fill"
        d="M45.2626 27.1022H28.3917V28.9689H45.2626V27.1022Z"
        fill="white"
      />
    </svg>
  )
}
